import { trustedOrigins } from '../API/instance/createInstance';
import { localStorageUtil } from './localStorageUtils';
import { getPropertyFromToken } from './funcUtils';

export const PostMessageTypes = {
  INJ_USER: 'INJ_USER',
  OPENED_READY: 'openedReady',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  DOC_SIGNED: 'DOC_SIGNED',
  DOCS_SIGNED: 'DOCS_SIGNED',
  DOC_RECEIVED: 'DOC_RECEIVED',
  ACCESS_DENIED: 'ACCESS_DENIED',
  ALREADY_SIGNED: 'ALREADY_SIGNED',
  DOC_NOT_FOUND: 'DOC_NOT_FOUND',
  NO_DOCS_TO_SIGN: 'NO_DOCS_TO_SIGN',
  EFIRMA_SINGLE_SIGN_STARTED: 'EFIRMA_SINGLE_SIGN_STARTED',
  EFIRMA_SIGN_MULTI_DOCS_STARTED: 'EFIRMA_SIGN_MULTI_DOCS_STARTED',
  AUTOGRAPH_SINGLE_SIGN_STARTED: 'AUTOGRAPH_SINGLE_SIGN_STARTED',
  AUTOGRAPH_SIGN_MULTI_DOCS_STARTED: 'AUTOGRAPH_SIGN_MULTI_DOCS_STARTED',
  SINGLE_SIGN_STARTED: 'SINGLE_SIGN_STARTED',
  SIGN_MULTI_DOCS_STARTED: 'SIGN_MULTI_DOCS_STARTED',
  SIGNATURE_CREATION_STARTED: 'SIGNATURE_CREATION_STARTED',
  CREATE_SIGNATURE_SUCCESS: 'CREATE_SIGNATURE_SUCCESS',
  VERIFICATION_STARTED: 'VERIFICATION_STARTED',
  VERIFY_SUCCESS: 'VERIFY_SUCCESS',
  VIDEO_AGREEMENT_STARTED: 'VIDEO_AGREEMENT_STARTED',
  VIDEO_AGREEMENT_COMPLETED: 'VIDEO_AGREEMENT_COMPLETED',
  FILE_VIEWER_OPENED: 'FILE_VIEWER_OPENED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
};

export const windowUtil = {
  preventAutoClose: function (e) {
    e.preventDefault();
    e.returnValue = '';
  },
};

export function handleSifeMessage(e) {
  if (/^react-devtools/gi.test(e.data.source)) {
    e.target.removeEventListener('message', handleSifeMessage);
    return null;
  }
}

export const windowPostUtil = ({ data, cbOnSuccess, cbOnFail, message }) => {
  function messgeReceiver(event) {
    if (/^react-devtools/gi.test(event.data.source)) {
      return null;
    }
    window.removeEventListener('message', messgeReceiver, false);
    const { data } = event;
    if (!data.success) {
      cbOnFail();
    } else {
      cbOnSuccess();
    }
    return data.success;
  }

  const sifeUser = {
    id: data._id,
    email: data.email,
    rfc: data.rfc,
    name: data.name,
    lastNameP: data.lastNameP,
    lastNameM: data.lastNameM,
    token_sife: localStorageUtil.getToken().token,
  };

  sendPostMessage({ payload: sifeUser, closeWindow: false });
  window.addEventListener('message', messgeReceiver);

  return;
};

function handleMessage(event) {
  if (/^react-devtools/gi.test(event.data.source)) {
    // event.target.removeEventListener('message', handleMessage);
    return null;
  }

  if (!trustedOrigins.includes(event.origin)) {
    return null;
  }

  sessionStorage.setItem('parentWindowLocation', event.origin);
  if (event.data.type === 'INJ_USER') {
    const { user } = event.data.payload;
    const token = localStorageUtil.getToken();
    localStorageUtil.setUserSession(user);
    if (token && Date.now() > token.exp) {
      sendPostMessage({ payload: { message: 'TOKEN_EXPIRED' } });
      // window.location.reload();
    }
  }
  if (event.data.message === 'openerMessage') {
    window.removeEventListener('message', handleMessage);
  }
}

export const setMessageReceiver = function () {
  window.addEventListener('message', handleMessage, false);
  sendPostMessage({ payload: { message: 'openedReady' }, closeWindow: false });
};

export const sendPostMessage = ({ payload, closeWindow = true }) => {
  const originUrl = getPropertyFromToken({
    token: localStorageUtil.getToken().token,
    property: 'originUrl',
  });
  if (originUrl && !trustedOrigins.includes(originUrl)) {
    trustedOrigins.push(originUrl);
  }

  // send postMessage if popup is opened
  if (window.opener) {
    trustedOrigins.forEach((origin) => {
      window.opener.postMessage(payload, origin);
    });

    if (closeWindow) {
      window.close();
    }
  }

  // send postMessage if iframe is opened
  if (window.self !== window.top) {
    trustedOrigins.forEach((origin) => {
      window.parent.postMessage(payload, origin);
    });
  }
};

export const inIframe = () => window.self !== window.top;
